{
  "EMOJI": {
    "PLACEHOLDER": "חפש אימוג'י",
    "NOT_FOUND": "אין אמוג'י שתואם את החיפוש שלך",
    "REMOVE": "הסר"
  }
}
